import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { formatCombo } from 'utils/platform';
import {
  UserDropdownItem, CustomLink, ItemLabel, ShortcutHint
} from './styled';

const DropdownItem = ({
  Modal = undefined, action = undefined, link = undefined, children, shortcut = undefined, badge = undefined
}) => {
  const content = (
    <>
      <ItemLabel>{children}</ItemLabel>
      {badge}
      {shortcut && <ShortcutHint>{formatCombo(shortcut)}</ShortcutHint>}
    </>
  );

  const generateDropdownLink = (url, description) => (
    <UserDropdownItem>
      <CustomLink to={ url }>
        {description}
      </CustomLink>
    </UserDropdownItem>
  );

  const generateDropdownModal = (toggleModal, description) => <UserDropdownItem onClick={ toggleModal }>{description}</UserDropdownItem>;

  const generateDropdownAction = (action, description) => (
    <UserDropdownItem onClick={ (e) => action(e) }>{description}</UserDropdownItem>
  );

  let Component;
  if (Modal) {
    Component = generateDropdownModal(Modal.toggleModal, content);
  } else if (action) {
    Component = generateDropdownAction(action, content);
  } else if (link) {
    Component = generateDropdownLink(link, children);
  }

  return Component;
};

DropdownItem.propTypes = {
  Modal: PropTypes.shape({ toggleModal: PropTypes.func }),
  action: PropTypes.func,
  link: PropTypes.string,
  children: PropTypes.node.isRequired,
  shortcut: PropTypes.string,
  badge: PropTypes.node
};

export default withRouter(DropdownItem);
